import { PLATFORM_ENVIRONMENT_BACKEND_API_ROOT_PROD, PLATFORM_ENVIRONMENT_ROOT_PROD } from '@platform-frontend/checkout-drop-in';
import { PlatformEnvironmentName } from './platform-environment-name';
function getEnvironmentName(): PlatformEnvironmentName {
  if (typeof window === 'undefined') return 'PRODUCTION';

  const hostname = window.location.hostname.toLowerCase();

  if (hostname.endsWith('yatta.local')) return 'DEV';
  if (hostname.includes('preview.')) return 'PREVIEW';
  if (hostname.includes('showcase.')) return 'SHOWCASE';
  if (hostname.includes('stage.')) return 'STAGE';

  return 'PRODUCTION';
}

function getEnvironmentRoot(prefix: string): string {
  const hostname = window.location.hostname.toLowerCase();
  const splittedHostname = hostname.split('yatta');
  if (splittedHostname.length < 2) throw new Error('Non-Yatta URL detected: ' + hostname);

  const subdomain = splittedHostname[0];
  return 'https://' + prefix + subdomain + 'yatta' + splittedHostname[1];
}

export const PLATFORM_ENVIRONMENT_NAME: PlatformEnvironmentName = getEnvironmentName();
export const PLATFORM_ENVIRONMENT_ROOT: string = PLATFORM_ENVIRONMENT_NAME === 'PRODUCTION' ? PLATFORM_ENVIRONMENT_ROOT_PROD : getEnvironmentRoot('');
export const PLATFORM_ENVIRONMENT_BACKEND_API_ROOT: string =
  PLATFORM_ENVIRONMENT_NAME === 'PRODUCTION' ? PLATFORM_ENVIRONMENT_BACKEND_API_ROOT_PROD : getEnvironmentRoot('api.');
